const steps = [
  {
    step: "1",
    title: "Apply",
    description: "Submit your application and business details for review.",
  },
  {
    step: "2",
    title: "Internal Review",
    description:
      "Our team confirms your eligibility and reviews your offering document for completeness.",
  },
  {
    step: "3",
    title: "Launch Campaign",
    description: "Your offering goes live and investors can start investing.",
  },
  {
    step: "4",
    title: "Receive Funds",
    description: "Once funded, receive your capital and grow your business.",
  },
];

export function RaiseHowItWorksSection() {
  return (
    <section className="bg-muted/30 py-16 sm:py-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-12 xl:px-16">
        <h2 className="mb-12 text-center text-3xl font-bold">How It Works</h2>
        <div className="mx-auto grid max-w-4xl gap-8 md:grid-cols-2 lg:grid-cols-4">
          {steps.map((step) => (
            <div key={step.step} className="text-center">
              <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-accent text-xl font-bold text-accent-foreground">
                {step.step}
              </div>
              <h3 className="mb-2 font-semibold">{step.title}</h3>
              <p className="text-sm text-muted-foreground">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
